import React, { useRef } from 'react';
import Props from '../../Components/Props';
import FormikFields from 'components/FormikFields';
import JSXCode from '../../Components/JSXCode';
import { Form, Formik } from 'formik';
import NewDesign from 'components/NewDesign';
import { showError } from 'helpers/handleError';
import DidServices from 'services/DidServices';
import { convertToFormSelect, getNextDataRefetch } from 'helpers';
import Timer from 'helpers/setTimer';
import PromiseHandler from 'helpers/promiseHandler';

const TabAsyncSelect = (props) => {
  //! State
  const timerInputSearch = useRef(new Timer());
  const promiseHandler = useRef(new PromiseHandler());

  //! Function

  //! Render
  return (
    <div className='component:TabAsyncSelect'>
      <Formik initialValues={{ didGroup: '', didGroups: [] }} onSubmit={() => {}}>
        {({ values }) => {
          return (
            <Form>
              <div>
                <div className='tw-grid tw-grid-cols-2 tw-gap-2'>
                  <FormikFields.AsyncSelect
                    name='didGroup'
                    label='DID Group'
                    placeholder='Select DID Group'
                    loadOptions={(inputValue, setOptions, _, onSuccess) => {
                      try {
                        timerInputSearch.current.debounce(() => {
                          const body = {
                            offset: 0,
                            limit: 20,
                            name: inputValue,
                          };

                          promiseHandler.current
                            .takeLatest(Promise.all([DidServices.loadDIDGroup(body)]))
                            .then((res) => {
                              const [result, isLast] = getNextDataRefetch(res, 20);

                              const resultCallback = convertToFormSelect(result, 'name', 'id');
                              onSuccess && onSuccess(result, isLast);
                              setOptions && setOptions(resultCallback);
                            })
                            .catch((err) => !err.isCanceled && showError(err));
                        }, 700);
                      } catch (error) {
                        showError(error);
                      }
                    }}
                    closeMenuOnSelect
                    isClearable
                    required
                  />
                  <FormikFields.AsyncSelect
                    name='didGroups'
                    label='DID Groups'
                    placeholder='Select DID Group'
                    loadOptions={(inputValue, setOptions, _, onSuccess) => {
                      try {
                        timerInputSearch.current.debounce(() => {
                          const body = {
                            offset: 0,
                            limit: 20,
                            name: inputValue,
                          };

                          promiseHandler.current
                            .takeLatest(Promise.all([DidServices.loadDIDGroup(body)]))
                            .then((res) => {
                              const [result, isLast] = getNextDataRefetch(res, 20);

                              const resultCallback = convertToFormSelect(result, 'name', 'id');
                              onSuccess && onSuccess(result, isLast);
                              setOptions && setOptions(resultCallback);
                            })
                            .catch((err) => !err.isCanceled && showError(err));
                        }, 700);
                      } catch (error) {
                        showError(error);
                      }
                    }}
                    isMulti
                    isClearable
                    required
                  />
                </div>

                <NewDesign.Separator className='tw-my-3' />

                <NewDesign.Badge v2 className='tw-mb-2'>
                  V2
                </NewDesign.Badge>
                <div className='tw-flex tw-gap-2'>
                  <FormikFields.AsyncSelect
                    name='didGroup'
                    label='DID Group'
                    placeholder='Select DID Group'
                    loadOptions={(inputValue, setOptions, _, onSuccess) => {
                      try {
                        timerInputSearch.current.debounce(() => {
                          const body = {
                            offset: 0,
                            limit: 20,
                            name: inputValue,
                          };

                          promiseHandler.current
                            .takeLatest(Promise.all([DidServices.loadDIDGroup(body)]))
                            .then((res) => {
                              const [result, isLast] = getNextDataRefetch(res, 20);

                              const resultCallback = convertToFormSelect(result, 'name', 'id');
                              onSuccess && onSuccess(result, isLast);
                              setOptions && setOptions(resultCallback);
                            })
                            .catch((err) => !err.isCanceled && showError(err));
                        }, 700);
                      } catch (error) {
                        showError(error);
                      }
                    }}
                    isClearable
                    required
                    v2
                  />
                  <FormikFields.AsyncSelect
                    name='didGroups'
                    label='DID Groups'
                    placeholder='Select DID Group'
                    loadOptions={(inputValue, setOptions, _, onSuccess) => {
                      try {
                        timerInputSearch.current.debounce(() => {
                          const body = {
                            offset: 0,
                            limit: 20,
                            name: inputValue,
                          };

                          promiseHandler.current
                            .takeLatest(Promise.all([DidServices.loadDIDGroup(body)]))
                            .then((res) => {
                              const [result, isLast] = getNextDataRefetch(res, 20);

                              const resultCallback = convertToFormSelect(result, 'name', 'id');
                              onSuccess && onSuccess(result, isLast);
                              setOptions && setOptions(resultCallback);
                            })
                            .catch((err) => !err.isCanceled && showError(err));
                        }, 700);
                      } catch (error) {
                        showError(error);
                      }
                    }}
                    isMulti
                    isClearable
                    required
                    v2
                  />
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>

      <div className='tw-mt-3'>
        <JSXCode
          code={`
const timerInputSearch = useRef(new Timer());
const promiseHandler = useRef(new PromiseHandler());

<Formik initialValues={{ gender: '', genders: [] }} onSubmit={() => {}}>
{({ values }) => {
    return (
    <Form>
        <FormikFields.AsyncSelect
            name='didGroups'
            label='DID Groups'
            placeholder='Select DID Group'
            loadOptions={(inputValue, setOptions, _, onSuccess) => {
                try {
                    timerInputSearch.current.debounce(() => {
                        const body = {
                            offset: 0,
                            limit: 20,
                            name: inputValue,
                        };

                        promiseHandler.current
                        .takeLatest(Promise.all([DidServices.loadDIDGroup(body)]))
                        .then((res) => {
                            const [result, isLast] = getNextDataRefetch(res, 20);

                            const resultCallback = convertToFormSelect(result, 'name', 'id');
                            onSuccess && onSuccess(result, isLast);
                            setOptions && setOptions(resultCallback);
                        })
                        .catch((err) => !err.isCanceled && showError(err));
                    }, 700);
                } catch (error) {
                    showError(error);
                }
            }}
            isMulti
            isClearable
            required
            v2
        />
      
    </Form>
    );
}}
</Formik>
`}
        />
      </div>

      <Props
        className='tw-mt-5'
        source={[
          {
            prop: 'name',
            type: 'string',
            default: 'undefined',
          },
          {
            prop: 'label',
            type: 'any',
            default: 'undefined',
          },
          {
            prop: 'placeholder',
            type: 'string',
            default: 'undefined',
          },
          {
            prop: 'afterOnChange',
            type: '(nextValue) => void',
            default: 'undefined',
          },
          { prop: 'className', type: 'string', default: 'undefined' },
          { prop: 'classNameContainer', type: 'string', default: 'undefined' },
          {
            prop: 'closeMenuOnSelect',
            type: 'boolean',
            default: 'true',
          },
          {
            prop: 'isDisabled',
            type: 'boolean',
            default: 'false',
          },
          {
            prop: 'isMulti',
            type: 'boolean',
            default: 'false',
          },
          {
            prop: 'isLoading',
            type: 'boolean',
            default: 'false',
          },
          {
            prop: 'isClearable',
            type: 'boolean',
            default: 'false',
          },
          {
            prop: 'required',
            type: 'boolean',
            default: 'false',
          },
        ]}
      />
    </div>
  );
};

export default TabAsyncSelect;
